/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.trello.integration.OAuthRpc
 */

import type {
  ChirpAvroRpcDetails,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */
export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */
export type ChirpMethodCoordinates = { service: string; method: string };

export type EmptyError = {
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry?: boolean;
};

export type OAuthCallbackResponse = {
  success: Default<boolean>;
  message?: string;
};

export type StartOAuthResponse = { redirectUrl?: string };

export type StartResponseType = StartOAuthResponse;
export type StartErrorType = EmptyError & HubspotMetadata;
export const startRpc: ChirpAvroRpcDetails<
  undefined,
  StartResponseType,
  StartErrorType,
  false
> = {
  serviceName: 'com.hubspot.trello.integration.OAuthRpc',
  rpcName: 'start',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA_mUaUPcPYLJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type CallbackResponseType = OAuthCallbackResponse;
export type CallbackErrorType = EmptyError & HubspotMetadata;
export const callbackRpc: ChirpAvroRpcDetails<
  undefined,
  CallbackResponseType,
  CallbackErrorType,
  false
> = {
  serviceName: 'com.hubspot.trello.integration.OAuthRpc',
  rpcName: 'callback',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAA1r1QohIiacZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
